import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import API from "../api/axios";
import toast from "react-hot-toast";

export default function Register() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    business_name: "", email: "", password: "", phone: "", address: ""
  });
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await API.post("/auth/register", form);
      toast.success("Account created! Please sign in.");
      navigate("/login");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        <div style={styles.logo}>
          <img
  src="/logo.png"
  alt="MartSense"
  style={{ width: "80px", height: "80px", objectFit: "contain",flexShrink: 0, marginRight: "-14px"}}
/>
          <span style={{ fontSize: "28px", fontWeight: "800", whiteSpace: "nowrap", letterSpacing: "-0.3px" }}>
          <span style={{ color: "#2ec4b6" }}>Mart</span>
          <span style={{ color: "#f6a809" }}>Sense</span>
          </span>
        </div>
        {/* Hero image */}
<div style={{
  position: "relative",
  height: "180px",
  overflow: "hidden",
}}>
  <img
    src="/splash.JPG"
    alt="MartSense"
    style={{
      width: "100%",
      height: "100%",
      objectFit: "cover",
      objectPosition: "center top",
      display: "block",
    }}
  />
  <div style={{
    position: "absolute",
    bottom: "-2px", left: 0, right: 0,
    height: "50px",
    background: "#0f1a1a",
    borderRadius: "50% 50% 0 0 / 100% 100% 0 0",
  }} />
</div>
        <h1 style={styles.title}>Create your account</h1>
        <p style={styles.sub}>Start tracking inventory in minutes</p>

        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.field}>
            <label style={styles.label}>Business Name</label>
            <input
              name="business_name" type="text" value={form.business_name}
              onChange={handleChange} placeholder="My Store Ltd"
              required style={styles.input}
            />
          </div>

          <div style={styles.field}>
            <label style={styles.label}>Email</label>
            <input
              name="email" type="email" value={form.email}
              onChange={handleChange} placeholder="you@business.com"
              required style={styles.input}
            />
          </div>

          <div style={styles.field}>
            <label style={styles.label}>Password</label>
            <div style={styles.inputWrap}>
              <input
                name="password"
                type={showPassword ? "text" : "password"}
                value={form.password}
                onChange={handleChange}
                placeholder="••••••••"
                required
                autoComplete="new-password"
                style={styles.input}
                />
              <button
  type="button"
  onClick={() => setShowPassword(!showPassword)}
  style={styles.eyeBtn}
>
  {showPassword ? (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#5a8a8a" strokeWidth="2">
      <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94"/>
      <path d="M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19"/>
      <line x1="1" y1="1" x2="23" y2="23"/>
    </svg>
  ) : (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#5a8a8a" strokeWidth="2">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
      <circle cx="12" cy="12" r="3"/>
    </svg>
  )}
</button>
            </div>
          </div>

          <div style={styles.field}>
            <label style={styles.label}>Phone</label>
            <input
              name="phone" type="text" value={form.phone}
              onChange={handleChange} placeholder="08012345678"
              style={styles.input}
            />
          </div>

          <div style={styles.field}>
            <label style={styles.label}>Address</label>
            <input
              name="address" type="text" value={form.address}
              onChange={handleChange} placeholder="Lagos, Nigeria"
              style={styles.input}
            />
          </div>

          <button type="submit" disabled={loading} style={styles.btn}>
            {loading ? "Creating account..." : "Create Account"}
          </button>
        </form>

        <p style={styles.footer}>
          Already have an account?{" "}
          <Link to="/login" style={styles.link}>Sign in</Link>
        </p>
      </div>
    </div>
  );
}

const styles = {
  wrapper: {
    minHeight: "100vh", display: "flex", alignItems: "center",
    justifyContent: "center", background: "#0a0f0f", padding: "20px",
  },
  page: {
  minHeight: "100vh",
  background: "#0a0f0f",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "20px",
  boxSizing: "border-box",
},
card: {
  width: "100%",
  maxWidth: "440px",
  background: "#0f1a1a",
  borderRadius: "20px",
  overflow: "hidden",
  border: "1px solid #1e3333",
  boxShadow: "0 8px 32px rgba(0,0,0,0.4)",
  marginTop: "20px",
  marginBottom: "20px",
},
submitBtn: {
  background: "linear-gradient(135deg, #21bdae, #1a9e92)",
  color: "#0a0f0f",
  border: "none",
  borderRadius: "12px",
  padding: "16px",
  fontSize: "16px",
  fontWeight: "700",
  cursor: "pointer",
  width: "100%",
  marginBottom: "20px",
  boxSizing: "border-box",
},
formSection: {
  padding: "12px 32px 40px",
  boxSizing: "border-box",
},
  logo: { display: "flex", alignItems: "center", gap: "10px", marginBottom: "32px" },
  logoIcon: { fontSize: "32px" },
  logoText: { fontSize: "26px", fontWeight: "700", color: "#2ec4b6", letterSpacing: "-0.5px" },
  title: { fontSize: "26px", fontWeight: "700", color: "#e8f5f5", marginBottom: "8px", letterSpacing: "-0.5px" },
  sub: { fontSize: "14px", color: "#5a8a8a", marginBottom: "32px" },
  form: { display: "flex", flexDirection: "column", gap: "16px" },
  field: { display: "flex", flexDirection: "column", gap: "8px" },
  label: { fontSize: "13px", fontWeight: "500", color: "#5a8a8a" },
  inputWrap: { position: "relative" },
  input: {
    background: "#162424", border: "1px solid #1e3333", borderRadius: "10px",
    padding: "12px 48px 12px 16px", color: "#e8f5f5", fontSize: "15px",
    outline: "none", width: "100%",
  },
  eyeBtn: {
    position: "absolute", right: "14px", top: "50%",
    transform: "translateY(-50%)", background: "none",
    border: "none", fontSize: "18px", cursor: "pointer",
  },
  btn: {
    background: "linear-gradient(135deg, #2ec4b6, #1a9e92)",
    color: "#0a0f0f", border: "none", borderRadius: "10px",
    padding: "14px", fontSize: "15px", fontWeight: "700", marginTop: "8px",
  },
  footer: { textAlign: "center", marginTop: "24px", fontSize: "14px", color: "#5a8a8a" },
  link: { color: "#2ec4b6", textDecoration: "none", fontWeight: "600" },
};